import React, { useEffect, useState } from 'react';
import DrupalAccessTokenApi from "../../../js/csf/DrupalAccessTokenApi";
import { startLoadingSpinner, stopLoadingSpinner } from '../../csf-ufc-pivotal/includes/utils';
import PivotalSearchApi from "../../../js/csf/pivotal/PivotalSearchApi";
import CsfFournisseurPagination from "../includes/csf-fournisseur-pagination";
import { buildSearchConditionsContains, getSortingQuery, formatDate, navigateWithParams, clearSearchBtn } from '../includes/utils';
import PropTypes from "prop-types";

// import style
import './csf-fournisseur-recognition-renewal.scss';

export function CsfPivotalFournisseurRecognitionRenewal({ apiUrl, apiEnv, accessToken, urlRequestRecognition }) {

  const langcode = document.documentElement.lang;
  const [formations, setFormations] = useState([]);
  const [inputSearchValue, setInputSearchValue] = useState('');
  const [startRow, setStartRow] = useState(1);
  const [total, setTotal] = useState(0);
  const [isSearch, setIsSearch] = useState(false);
  const [sorting, setSorting] = useState('');
  const [sortingDirection, setSortingDirection] = useState("desc");
  const [sortingTerm, setSortingTerm] = useState("descending");
  const [buttonEnable, setButtonEnable] = useState();
  const [trainingSelected, setTrainingSelected] = useState('');
  const offset = 3;
  /*
  * When the accessToken is fetched and state is updates, get the formations lists.
  * */
  useEffect(() => {
    if (accessToken) {
      startLoadingSpinner();
      getFormationsList();
      setIsSearch(false);
    }
  }, [accessToken, startRow, isSearch, sorting, sortingDirection]);

  /*
  * Init the bootstrap tooltips on list change
  * */
  useEffect(() => {
    if (formations) {
      $('[data-toggle="tooltip"]').tooltip({
        customClass: 'sup-tooltip'
      });
    }
  }, [formations]);

  /*
  * Enables the Selection button if a training is picked and the condition is checked.
  * */
  useEffect(() => {
    if (trainingSelected) {
      setButtonEnable(true);
    } else {
      setButtonEnable(false);
    }
  }, [trainingSelected]);

  /*
  * Method to fetch the formations lists of the users.
  * */
  function getFormationsList() {
    const requestData = buildMainBodyDataResquest();
    const pivotalSearchApi = new PivotalSearchApi(apiUrl, apiEnv, accessToken);
    pivotalSearchApi.callSearchEndpoint(requestData, '_Espace_Partenaire')
      .then(response => {
        if (response?.success && response?.payload?.data?.rows?.length >= 0) {
          setFormations(response.payload.data.rows);
          setTotal(response.payload.data.searchTotal);
          stopLoadingSpinner();
        }
      })
      .catch(error => {
        stopLoadingSpinner();
        console.error(error);
      });
  }

  /*
  * Method to build the body array for the request
  * */
  function buildMainBodyDataResquest() {
    let requestData = {
      maxRows: offset,
      startRow: startRow,
      ParameterValues: [""],
      search: 'CSF_EP_Activity_Status_REST',
      matchCondition: 1,
      searchResultsList: 'CSF_EP_Activity_SRL'
    };

    if (sorting !== '') {
      requestData.sort = getSortingQuery(sorting, sortingDirection);
    }
    //Remove characters from the string, before sending it to pivotal.
    let filteredSearchValue = inputSearchValue.replace(/[#$]/g,"");

    let searchConditions = buildSearchConditionsContains(filteredSearchValue, ["Name_French", "Name_English", "Recognition_Code"]);

    if (searchConditions.length > 0) {
      requestData.conditions = searchConditions;
    }

    return requestData;
  }

  /*
  * Method that handle the value changed on the search bar.
  * */
  function handleSearchChange(event) {
    const value = event.target.value;
    setInputSearchValue(value);
  }

  /*
  * Method that handle the click on the search Btn of the search bar
  * */
  function handleSearchBtn(event) {
    if (event.key === 'Enter' || event.type === "click") {
      setIsSearch(true);
      setStartRow(1);
    }
  }

  /*
  * Method that trigger an empty search when X button is clicked in the search field.
  * */
  function retriggerEmptySearch() {
    setInputSearchValue("");
    setIsSearch(true);
    setStartRow(1);
  }

  /*
  * Method that handle the click on the sorting titles
  * */
  function handleSortingClick(sortHandle) {
    if (sortHandle === sorting) {
      setSortingDirection((prevDirection) => (prevDirection === 'desc' ? 'asc' : 'desc'));
      setSortingTerm((prevDirection) => (prevDirection === 'descending' ? 'ascending' : 'descending'));
    } else {
      setSorting(sortHandle);
      setSortingDirection('desc');
      setSortingTerm('descending');
    }
  }

  /*
  * Method that handle the change on the Trainings radio button
  * */
  function handleTrainingSelection(e) {
    setTrainingSelected(e.target.value);
  }

  function handleClickSelectButton() {
    const urlParams = {
      activity: trainingSelected,
      renewal: true,
    };
    navigateWithParams(urlRequestRecognition, urlParams);
  }

  function resetModal() {
    // Reset the checked/selected inputs
    const radio = document.querySelector('#recognitionRenewalModal input[type="radio"]:checked');
    const checkbox = document.querySelector('#condition_accepted:checked');

    if (radio) {
      radio.checked = false;
    }

    if (checkbox) {
      checkbox.click();
    }

    setInputSearchValue('');
    setIsSearch(false);
    setButtonEnable(false);
    setTrainingSelected('');
    setSorting('End_Date');
    setSortingDirection('desc');
    setSortingTerm('descending');
  }

  return (
    <div className="modal fade" id="recognitionRenewalModal" role="dialog" aria-labelledby="recognitionRenewalModalTitle"
      aria-hidden="true">
      <div className="modal-dialog modal-lg modal-dialog-centered modal-dialog-scrollable">
        <div className="modal-content">
          <div className="modal-header">
            <h2 id="recognitionRenewalModalTitle">{window.Drupal.t('fournisseur.recognition.renewal.modal.title')}</h2>
            <button type="button" className="close" data-dismiss="modal" onClick={resetModal}
              aria-label={window.Drupal.t('lang.modal.close')}>
              <i className="icon icon-csf-close-noborder"><span className="d-none">&nbsp;</span></i>
            </button>
          </div>

          <div className="modal-body recognition-renewal-list">
            <div className="search-limiter">
              <div className="search-container">
                <label htmlFor="recognitionRenewalSearch" className="sr-only">{window.Drupal.t('search.label')}</label>
                <input type="search" id="recognitionRenewalSearch" value={inputSearchValue} onChange={handleSearchChange} onKeyDown={handleSearchBtn}
                  placeholder={window.Drupal.t('fournisseur.search.activities.placeholder')} />
                <button className="search-close-icon btn-link" aria-label={window.Drupal.t('fournisseur.search.clear.label')}
                  onClick={(e) => {
                    clearSearchBtn(e, setInputSearchValue);
                    retriggerEmptySearch();
                  }} >
                  <i className="icon icon-remove"></i>
                </button>
                <button className="button btn-outlined search-icon" onClick={handleSearchBtn}
                  title={window.Drupal.t('search.label')} aria-label={window.Drupal.t('search.label')}>
                  <i className="icon icon-search-2"><span className="d-none">&nbsp;</span></i>
                </button>
              </div>
            </div>

            <div className="table-wrapper">
              <table id="recognition-renewal-list-table" className="recognition-renewal-table">
                <caption id="recognition-renewal-caption" className="sr-only">{window.Drupal.t('fournisseur.recognition.renewal.modal.title')}</caption>
                <thead>
                  <tr>
                    <th width="40"></th>
                    <th aria-sort={sorting === 'Name_French' ? sortingTerm : 'none'}>
                      <button className={`sort ${sorting === 'Name_French' ? sortingDirection : ''}`} onClick={() => handleSortingClick("Name_French")}>
                        {window.Drupal.t('fournisseur.activities-list.table.name')}
                      </button>
                    </th>
                    <th className="reco-renewal-status" aria-sort={sorting === 'Status_Activity' ? sortingTerm : 'none'}>
                      <button className={`sort ${sorting === 'Status_Activity' ? sortingDirection : ''}  d-flex align-items-center`} onClick={() => handleSortingClick("Status_Activity")}>
                        {window.Drupal.t('fournisseur.activities-list.table.status')}
                      </button>
                    </th>
                    <th width="30%" className="smaller-th" aria-sort={sorting === 'EndDate' ? sortingTerm : 'none'}>
                      <button className={`sort multiple-th ${sorting === 'EndDate' ? sortingDirection : ''}`} onClick={() => handleSortingClick("EndDate")}>
                        <span className="multiple-th-wrapper">
                          {window.Drupal.t('fournisseur.activities-list.table.period')}
                        </span>
                      </button>
                    </th>
                  </tr>
                </thead>
                <tbody>
                  {formations.length === 0 ? (
                    <tr>
                      <td colSpan="6">
                        <p>{window.Drupal.t('fournisseur.empty.training.list')}</p>
                      </td>
                    </tr>
                  ) : (
                    formations.map((item) => {
                      return (
                        <tr key={item.REDU_Activity_Id}>
                          <td>
                            <div className="form-group d-flex align-items-center">
                              <input id={item.REDU_Activity_Id} onChange={handleTrainingSelection} value={item.REDU_Activity_Id} type="radio" name="trainingRenew" />
                              <label htmlFor={item.REDU_Activity_Id} className="sr-only">{item.Name_French}</label>
                            </div>
                          </td>
                          <td className="list-item-title">
                            {item.Name_French && (
                              <span className="prim">{item.Name_French.length > 55 ? `${item.Name_French.substring(0, 55)}...` : item.Name_French}</span>
                            )}
                            {item.Name_English && (
                              <span className="sec">{item.Name_English.length > 55 ? `${item.Name_English.substring(0, 55)}...` : item.Name_English}</span>
                            )}
                          </td>
                          <td className="list-item-activity">
                            <span className="prim">{item.Status_Activity}</span>
                            {item.LastModif && (
                              <span className="sec" dangerouslySetInnerHTML={{ __html: window.Drupal.t('fournisseur.last.modification.date.html') + ' ' + formatDate(item.LastModif) }}></span>
                            )}
                          </td>
                          <td className="list-item-validity">
                            <span className="prim">
                              {item.StartDate && (
                                <>
                                  {formatDate(item.StartDate, '2-digit')}
                                  {item.EndDate && (
                                    <> - {formatDate(item.EndDate, '2-digit')}</>
                                  )}
                                </>
                              )}
                            </span>
                            {item.Recognition_Code && (
                              <span className="sec">#{item.Recognition_Code}</span>
                            )}
                          </td>
                        </tr>
                      )
                    })
                  )}
                </tbody>
              </table>
            </div>
          </div>

          <div className="modal-footer">
            <div className="modal-footer-inner d-flex justify-content-between align-items-center">
              <div className="pagination-wrapper">
                <CsfFournisseurPagination
                  startRow={startRow}
                  offset={offset}
                  total={total}
                  setStartRowFunction={setStartRow}
                />
              </div>
              <div className="buttons-wrapper justify-content-end">
                <button type="button" className="button btn-outlined btn-larger" onClick={resetModal}
                  data-dismiss="modal">{window.Drupal.t('fournisseur.cancel.btn')}</button>
                <button type="button" className="button btn-larger" disabled={!buttonEnable}
                  onClick={handleClickSelectButton}>{window.Drupal.t('fournisseur.recognition.renewal.modal.select')}</button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

CsfPivotalFournisseurRecognitionRenewal.propTypes = {
  apiUrl: PropTypes.string,
  apiEnv: PropTypes.string,
  accessToken: PropTypes.string,
  urlRequestRecognition: PropTypes.string,
};
